import axios from "axios";

export default ({ getState, dispatch, next, action }) => {
    const { type, payload } = action;

    if (type === "FEDERATION-SETUP:RESEND-VERIFICATION-EMAIL") {
        axios.post("/portal/resend-verification-email")
            .then(() => {
                dispatch({ type: "FEDERATION-SETUP:RESEND-VERIFICATION-EMAIL-SUCCESS" });
            }, ({ response }) => {
                dispatch({
                    type: "FEDERATION-SETUP:RESEND-VERIFICATION-EMAIL-ERROR",
                    payload: response.data
                });
            });

        return next({ type: "FEDERATION-SETUP:RESEND-VERIFICATION-EMAIL-PENDING" });
    } else if (type === "FEDERATION-SETUP:GET-CONNECTION") {
        axios.get(`/portal/users/connections${payload.email ? ("/"+payload.email) : ""}`)
            .then(({ data: connection }) => {
                let status;
                const isSupporter = "cc:federation-support" in getState().auth.scopes;
                if (connection === '') {
                    status = "NO-CONNECTION-YET";
                } else if (connection.enabled) {
                    status = "CONNECTION-ENABLED";
                } else if (!isSupporter && connection.creatorUser !== getState().auth.data.sub) {
                    status = "STARTED-BY-OTHER-USER";
                } else if (connection.testSucceeded) {
                    status = "TEST-SUCCEEDED";
                } else {
                    status = "CONNECTION-CREATED";
                }
                dispatch({
                    type: "FEDERATION-SETUP:GET-CONNECTION-SUCCESS",
                    payload: { connection, status }
                });
            }, ({ response }) => {
                dispatch({
                    type: "FEDERATION-SETUP:GET-CONNECTION-ERROR",
                    payload: response.data
                });
            });

        return next({ type: "FEDERATION-SETUP:GET-CONNECTION-PENDING" });
    } else if (type === "FEDERATION-SETUP:CREATE-CONNECTION") {
        axios.post(`/portal/connections${payload.email ? ("/"+payload.email) : ""}`, payload.params)
            .then(({ data: connection }) => {
                dispatch({
                    type: "FEDERATION-SETUP:CREATE-CONNECTION-SUCCESS",
                    payload: { connection, status: "CONNECTION-CREATED" }
                });
            }, ({ response }) => {
                dispatch({
                    type: "FEDERATION-SETUP:CREATE-CONNECTION-ERROR",
                    payload: response.data
                });
            });
        return next({ type: "FEDERATION-SETUP:CREATE-CONNECTION-PENDING" });
    } else if (type === "FEDERATION-SETUP:UPDATE-CONNECTION") {
        const { connectionId, params } = payload;
        axios.patch(`/portal/connections/${connectionId}`, { params })
            .then(({ data: connection }) => {
                dispatch({
                    type: "FEDERATION-SETUP:UPDATE-CONNECTION-SUCCESS",
                    payload: { connection, status: "CONNECTION-CREATED" }
                });
            }, ({ response }) => {
                dispatch({
                    type: "FEDERATION-SETUP:UPDATE-CONNECTION-ERROR",
                    payload: response.data
                });
            });

        return next({ type: "FEDERATION-SETUP:UPDATE-CONNECTION-PENDING" });
    } else if (type === "FEDERATION-SETUP:ENABLE-CONNECTION") {
        const { connectionId } = payload;
        axios.post(`/portal/connections/${connectionId}/enable`)
            .then(({ data: connection }) => {
                dispatch({
                    type: "FEDERATION-SETUP:ENABLE-CONNECTION-SUCCESS",
                    payload: { connection, status: "CONNECTION-ENABLED" }
                });
            }, ({ response }) => {
                dispatch({
                    type: "FEDERATION-SETUP:ENABLE-CONNECTION-ERROR",
                    payload: response.data
                });
            });

        return next({ type: "FEDERATION-SETUP:UPDATE-CONNECTION-PENDING" });
    }

    return next(action);
};
